module.exports = __webpack_public_path__ + "assets/images/inbox.svg?195ac82d79ff674f3497e5ae6d670951";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/inbox.svg
// module id = 614
// module chunks = 0